import { useParams } from "react-router-dom";
// import { usePublicResourceWithSuspense } from "@swivu/client-api";
// import ResourceDetailV2 from "../components/ResourceDetailV2.js";
import { useSettings } from "../hooks/useSettings.js";
import ResourceDetail from "@swivu/team-schedule/src/shared-public-and-wf/ResourceDetail.js";

const Resource = () => {
  const { resourceId, slug } = useParams();
  const { timezone } = useSettings();
  // const { data: resource } = usePublicResourceWithSuspense({
  //   variables: {
  //     slug: slug ?? "",
  //     id: resourceId ?? ""
  //   }
  // });
  // const data = {
  //   ...resource,
  //   id: resource.id,
  //   display_name: resource.display_name ?? resource.label ?? "",
  //   label: resource.label ?? "",
  //   job_title: resource.job_title ?? null,
  //   type: resource.type_description ?? null,
  //   status: resource.status_value ?? null,
  //   category: resource.category_value ?? null,
  //   team: resource.team_name ?? null,
  //   icon: resource.icon_value ?? null,
  //   icon_value: resource.icon_value ?? null,
  //   image_url: null,
  //   phone: null,
  //   description: null,
  //   email: null
  // };
  return (
    <div className="py-8 max-w-screen-lg mx-auto md:px-0 ">
      <h2 className="max-w-screen-sm text-xl pb-4  md:text-2xl md:pb-6 mx-auto">
        Resource
      </h2>
      <div className="grid grid-cols-1  gap-y-8 gap-x-6 justify-center">
        <div className="w-full max-w-screen-sm mx-auto">
          {/* <ResourceDetailV2 key={resource.id} data={data} /> */}
          <ResourceDetail.Provider
            slug={slug!}
            id={resourceId!}
            api="public"
            timezone={timezone}
            baseUrls={{
              checklist: `/p/${slug}/checklist/:id`
            }}
          >
            <ResourceDetail />
          </ResourceDetail.Provider>
        </div>
      </div>
    </div>
  );
};

export default Resource;
